import { useState, useEffect } from 'react';
import { useTheme } from '../context/ThemeContext.jsx';
import { fonts as fontsApi } from '../api/client.js';

export default function SimilarFonts({ fontId, onSelectFont }) {
  const { theme } = useTheme();
  const [similar, setSimilar] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!fontId) return;
    setLoading(true);
    fontsApi.similar(fontId)
      .then(data => setSimilar(data.similar || []))
      .catch(() => setSimilar([]))
      .finally(() => setLoading(false));
  }, [fontId]);

  if (loading) return <div style={{ color: theme.textMuted, fontSize: 11, padding: '8px 0' }}>Finding similar fonts...</div>;
  if (similar.length === 0) return null;

  return (
    <div style={{ marginBottom: 20 }}>
      <div style={{
        fontSize: 10, fontWeight: 600, color: theme.textFaint,
        marginBottom: 8, letterSpacing: '0.06em', textTransform: 'uppercase',
      }}>Similar Fonts</div>
      <div style={{
        display: 'flex', gap: 8, overflowX: 'auto', paddingBottom: 4,
      }}>
        {similar.map(f => (
          <button
            key={f.id}
            onClick={() => onSelectFont?.(f.id)}
            style={{
              minWidth: 110, padding: '10px 12px',
              background: theme.bgTertiary,
              border: `1px solid ${theme.borderLight}`,
              borderRadius: 8, cursor: 'pointer',
              textAlign: 'left', flexShrink: 0,
            }}
          >
            <div style={{
              fontFamily: `'${f.family}', serif`,
              fontSize: 16, color: theme.text, marginBottom: 4,
              overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
            }}>Aa</div>
            <div style={{
              fontSize: 10, fontWeight: 600, color: theme.textSecondary,
              overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
            }}>{f.name}</div>
            <div style={{ fontSize: 9, color: theme.textGhost }}>{f.category}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
